/*eslint-disable */
import React, { useEffect, useState } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import moment from "moment";
import { Form as FormUi, Container, TextArea, Button, Input, Segment, Dropdown, Icon, Search, } from "semantic-ui-react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { min, isEmpty } from "lodash";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import {
  createShipmentDispatcher,
  deleteAllOrderDispatcher,
} from "../../redux/actions/shipmentAction";
import MandatoryMark from "../common/mandatorymark";
import { DateData } from "../dynamicComponent/datepick";
import AddOrderDomestic from './addOrderDomestic';
import AddOrderImport from './addOrderImport';
import AddOrderExport from './addOrderExport';


const AddOrder = ({
  values,
  vehicleTypeMaster,
  setFieldValue,
  touched,
  errors,
  handleSubmit,
  shipment,
  shipmentEdit,
  routeCodes,
  routeNames,
  mode,
  isSubmitting,
  deleteAllOrderDispatcher,
  t,
  props
}) => {

  useEffect(() => {
  }, [])


  return (
    <React.Fragment>
      <Formiker>
        <Segment>
          <div className="ui form tiny p-bold-600">
            <FormUi.Group>
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {t("shipment_form.movement_type.title") || "Movement Type"}{" "}
                  <MandatoryMark />
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={
                  touched.movement_type && errors.movement_type ? true : false
                }
              >
                <Dropdown
                  name="movement_type"
                  clearable
                  style={{ width: "100%", fontWeight: "normal" }}
                  selection
                  placeholder={
                    t("shipment_form.movement_type.placeholder") ||
                    "Movement Type"
                  }
                  onChange={(name, data) => setFieldValue("movement_type", data.value)}
                  options={[
                    { key: "2", text: "Import", value: "import" },
                    { key: "3", text: "Primary", value: "primary" },
                    { key: "1", text: "Export", value: "export" },
                  ]}
                  value={values.movement_type}
                />
                {touched.movement_type && errors.movement_type ? (
                  <div className="w3-small w3-text-red">
                    {t(
                      `shipment_form.movement_type.error_msg.${errors.movement_type}`
                    ) || errors.movement_type}
                  </div>
                ) : null}
              </FormUi.Field>
              <FormUi.Field width={1} />
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {values.movement_type == "import" ? (
                    <>
                      {t("shipment_form.estimate_clearence_date.title") || "Estimated Clearance End Date"}{""}
                      <MandatoryMark />
                    </>
                  ) : (
                    <>
                      {t("shipment_form.required_on.title") || "Required On"}{" "}
                      <MandatoryMark />
                    </>
                  )}

                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.required_on && errors.required_on ? true : false}
                className="datepic">
                  <input placeholder='' />
              </FormUi.Field>
            </FormUi.Group>


            <FormUi.Group>
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {t("shipment_form.route_code.title") || "Route"}{" "}
                  <MandatoryMark />
                </label>
              </FormUi.Field>
              <FormUi.Field width={4} error={ touched.movement_type && errors.movement_type ? true : false
                }
              >
                 <input placeholder='' />
              </FormUi.Field>
              <FormUi.Field width={1} />
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {values.movement_type == "import" ? (
                    <>
                      {t("shipment_form.number_of_containers.title") || " No. of Containers"}{" "}
                      <MandatoryMark />
                    </>
                  ) : (
                    <>
                      {t("shipment_form.number_of_vehicles.title") ||
                        "Number Of Vehicles"}{" "}
                      <MandatoryMark />
                    </>
                  )}
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.required_on && errors.required_on ? true : false}
                className="datepic"
              >
                 <input placeholder='' />
              </FormUi.Field>
            </FormUi.Group>


            <FormUi.Group>
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {values.movement_type == "import" ? (
                    <>
                      {"Pickup Location"}{" "}
                      <MandatoryMark />
                    </>
                  ) : (
                    <>
                      {t("shipment_form.source.title") || "Source"}{" "}
                      <MandatoryMark />
                    </>
                  )}

                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={
                  touched.movement_type && errors.movement_type ? true : false
                }>
                  <input placeholder='' />
              </FormUi.Field>
              <FormUi.Field width={1} />
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {t("shipment_form.destination_d.title") || "Destination"}{" "}
                  <MandatoryMark />
                </label>
              </FormUi.Field>
              <FormUi.Field width={4}
                error={touched.required_on && errors.required_on ? true : false}
                className="datepic"
              >
                <input placeholder='' />

              </FormUi.Field>
            </FormUi.Group>

            <FormUi.Group>
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {t("shipment_form.service_type.title") || "Service Type"}{" "}
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={
                  touched.movement_type && errors.movement_type ? true : false
                }
              >
                  <select placeholder='' />
              </FormUi.Field>
              <FormUi.Field width={1} />
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {t("shipment_form.load_type.title") || "Load Type"}{" "}
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.required_on && errors.required_on ? true : false}
                className="datepic"
              >
                 <select placeholder='' />
              </FormUi.Field>
            </FormUi.Group>

            <FormUi.Group>
              <FormUi.Field width={3}>
                {values.movement_type != "import" && (
                  <label className="labelName mt-2">
                    {t("shipment_form.refernce_no.title") || "Reference No"}{" "}
                    {/* <MandatoryMark /> */}
                  </label>
                )}
                {values.movement_type == "import" && (
                  <label className="labelName mt-2">
                    {t("shipment_form.bl_no.title") ||
                      "BL Number"}{" "}
                    {/* <MandatoryMark /> */}

                  </label>
                )}
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={
                  touched.movement_type && errors.movement_type ? true : false
                }
              >
                 <input placeholder='' />
              </FormUi.Field>
              <FormUi.Field width={1} />
              <FormUi.Field width={3}>

              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.required_on && errors.required_on ? true : false}
                className="datepic"
              >
              </FormUi.Field>
            </FormUi.Group>

          </div>
        </Segment>
      </Formiker>
      <>
        {values.movement_type == "primary" ? (
          <>
            <AddOrderDomestic
            ></AddOrderDomestic>
          </>
        ) : (
          null
        )}

        {values.movement_type == "import" ? (
          <>
            <AddOrderImport
              movement_type={values.movement_type}
            ></AddOrderImport>
          </>
        ) : (
          null
        )}

        {values.movement_type == "export" ? (
          <>
            <AddOrderExport
            ></AddOrderExport>
          </>
        ) : (
          null
        )}
      </>
    </React.Fragment>
  );
};

const FormikShipment = withFormik({
  enableReinitialize: true,
  validationSchema: yup.object({
    movement_type: yup.string().required("required"),
  }),
  // setFieldValue("required_on", moment().format("DD/MM/yyyy hh:mm"));
  mapPropsToValues: (props) => (
    {
      movement_type: (props.shipmentEdit ? props.shipmentEdit.movement_type : localStorage.getItem("customerNumber") != 1122 ? "primary" : "import"),
    }),
  handleSubmit(values, { setFieldValue, setSubmitting, props }) {

  },
})(AddOrder);

const mapStateToProps = ({ shipment }) => {
  return {
    shipment,
  };
};

export default connect(mapStateToProps, {
  createShipmentDispatcher,
  successAlertDispatcher,
  errorAlertDispatcher,
  deleteAllOrderDispatcher,
})(translate("create_shipment")(FormikShipment));
